// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RROhJ","content":"styles_content__1bKZ8","tableWrap":"styles_tableWrap__12IHB"};